import React from 'react';

const Error = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <circle cx="9" cy="9" r="8" fill="white" />
    <circle cx="9" cy="9" r="9" fill="#F2F2F2" />
    <circle cx="9" cy="9" r="8" fill="#CB2C2C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.55362 6.78142C7.33773 6.61356 7.02558 6.62882 6.8272 6.8272C6.61229 7.04211 6.61229 7.39055 6.8272 7.60546L8.22109 8.99935L6.8272 10.3932L6.78142 10.4451C6.61356 10.661 6.62882 10.9731 6.8272 11.1715C7.04211 11.3864 7.39055 11.3864 7.60546 11.1715L8.99935 9.77761L10.3932 11.1715L10.4451 11.2173C10.661 11.3851 10.9731 11.3699 11.1715 11.1715C11.3864 10.9566 11.3864 10.6081 11.1715 10.3932L9.77761 8.99935L11.1715 7.60546L11.2173 7.55362C11.3851 7.33773 11.3699 7.02558 11.1715 6.8272C10.9566 6.61229 10.6081 6.61229 10.3932 6.8272L8.99935 8.22109L7.60546 6.8272L7.55362 6.78142Z"
      fill="white"
    />
  </svg>
);

export default Error;
